<template>
  <FKBreadCrumb :page="$t('page.edit')" :title="$t('page.edit_center')">
    <FKBreadCrumbItem :page="$t('page.centers')" to="/system-centers" />
    <FKBreadCrumbItem :page="`${center.name}`" :to="`/center/${center.id}`" />
  </FKBreadCrumb>
  <CenterForm />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import CenterForm from "@/components/FK/Center/CenterForm.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
import { CenterInfo } from "@/utils/models/center.model";

export default defineComponent({
  name: "UpdateCenterPage",
  computed: {
    center(): CenterInfo { return this.$route.meta.center as CenterInfo}
  },
  components: {
    FKBreadCrumb,
    FKBreadCrumbItem,
    CenterForm,
  },
});
</script>